module.exports = __webpack_public_path__ + "img/normativa-fiscalidad.e8318579.jpg";